import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input"];

  increment() { this.setValue(this.currentValue + 1); }
  decrement() { this.setValue(Math.max(0, this.currentValue - 1)); }
  change(event) { this.setValue(Number(event.target.value) || 0); }

  setValue(value) {
    this.inputTarget.value = value;
    const row = this.element.closest("[data-configurator-state-target='photoRow']");
    if (row) row.dataset.quantity = String(value);
    this.dispatch("changed", {
      detail: { photoId: row?.dataset.photoId, quantity: value },
      bubbles: true,
      prefix: "photo-quantity"
    });
  }

  get currentValue() {
    return Number(this.inputTarget.value) || 0;
  }
}
